import { createFileRoute, redirect } from "@tanstack/react-router";

import { orgUrlSegment } from "../orgRouting";
import { readLastPickedOrgId } from "../state/orgs";

/**
 * The legacy org-less regulation tree.
 *
 * Regulation is tenant-scoped like settings (`/$org/compliance/…`), so a
 * session with a known organization is redirected there. This route exists to
 * keep old links working — a bookmark to `/regulation/policies` still lands
 * on the right page instead of 404ing.
 *
 * With no known organization there is nothing to scope to, so it sends the
 * user to the chat root to pick one rather than guessing a tenant.
 */
const SECTION_ROUTES = {
  policies: "/$org/compliance/policies",
  procedures: "/$org/compliance/procedures",
  regulatory: "/$org/compliance/regulatory",
  knowledge: "/$org/compliance/knowledge",
} as const;

export const Route = createFileRoute("/compliance")({
  beforeLoad: async ({ context, location }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }

    const lastPickedOrgId = readLastPickedOrgId();
    if (!lastPickedOrgId) {
      throw redirect({ to: "/", replace: true });
    }

    const requested = location.pathname.slice("/compliance/".length);
    const to =
      requested in SECTION_ROUTES
        ? SECTION_ROUTES[requested as keyof typeof SECTION_ROUTES]
        : SECTION_ROUTES.policies;

    throw redirect({ to, params: { org: orgUrlSegment(lastPickedOrgId) }, replace: true });
  },
});
